(function () {
  function syncFromFastBundle(fbSelect) {
    var allFbSelects = document.querySelectorAll('select:not(.select-field)');
    if (allFbSelects[0] !== fbSelect) return; // only slot #1 drives the preview image
    var productDataEl = document.getElementById('product-data');
    var img = document.querySelector('.product-image-main');
    if (!productDataEl || !img) return;
    var product = JSON.parse(productDataEl.dataset.product);
    var key = (fbSelect.value || '').trim().toLowerCase();
    if (!key) return;
    var variant = product.variants.find(function (v) {
      return v.title.trim().toLowerCase() === key;
    });
    if (!variant) return;
    if (variant.featured_image) img.src = variant.featured_image.src;

    // Do NOT write into Shopify's native add-to-cart form (.select-field /
    // #ultimate-selected-variant) here, for single items or bundles. Doing so
    // makes the theme's native Webflow commerce form submit ALONGSIDE Fast
    // Bundle's own add-to-cart call, adding every item twice. This script is
    // preview-image-only; cart submission is left entirely to Fast Bundle.
  }
  function attachListeners() {
    document.querySelectorAll('select:not(.select-field)').forEach(function (fbSelect) {
      if (fbSelect.dataset.bundleSyncAttached) return;
      fbSelect.dataset.bundleSyncAttached = 'true';
      fbSelect.addEventListener('change', function () { syncFromFastBundle(fbSelect); });
    });
  }
  attachListeners();
  new MutationObserver(attachListeners).observe(document.body, { childList: true, subtree: true });
})();
